import React, { Fragment } from 'react'
import { Row, Col, Button, Progress, Form, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap'
import { ArrowRight, GraduationCap, ArrowsClockwise, Table } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Lessons from '../../components/Study/Lessons.jsx'
import Questions from '../../components/Study/Questions.jsx'
import { isEmpty, processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import Skeleton from '../../components/UI/Skeleton'
import SidebarEmulation from '../../components/Study/SidebarEmulation.jsx'
import TestEmulation from '../../components/Study/TestEmulation.jsx'
import HomeWorkModal from '../../components/Study/HomeWorkModal.jsx'
const cookies = new Cookies()

const TestCompleteModal = styled(Modal)`
    .subtitle {
        color: #212121;
    }
    .modal-body {
        padding-top: 20px !important;
    }
    .complete-status {
        padding: 20px 0;
        &.complete {
            color: #00A743;
        }
        &.uncomplete {
            color: #FF0000;
        }
    }
`
let timerInterval
class Study extends React.Component {
    constructor(props) {
        super(props)
        this.form = null
        this.state = {
            allCourses: [
                {
                    id: 0,
                    image: "",
                    title: "",
                    desc: "",
                    tags: [],
                    partners: [],
                    totalPartners: 0,
                    likes: 0,
                    type: '',
                    themes: [
                        {
                            id: 0,
                            title: "",
                            modules: [
                                {
                                    id: 0,
                                    title: "",
                                    type: "",
                                    available: false,
                                    complete: false,
                                },
                            ],
                        },
                    ],
                },
            ],
            course: {
                themes: [],
                title: '',
            },
            status: {
                completed: 0,
                from: 0,
                percent: 0,
            },
            module: {
                id: 0,
                data: { questions: [{ options: [] }] },
                nextId: -1,
                necessary: true,
            },
            allTable: {
                name: '',
                ratableTasks: [],
                rnratableTasks: [],
            },
            modalData: {
                name: '',
                ratableTasks: [],
                unratableTasks: [],
            },
            pageTitle: null,
            pageDescription: null,
            pageLink: null,
            testComplete: false,
            testStatus: 0,
            allowToContinue: false,
            testWithTime: false,
            testTimeLeft: 1000,
            testTimeLeftFormated: '',
            testHasQuestions: false,
            isLast: false,
            showModal: false,
            corrects: 0,
            total: 0,
            moduleLoaded: false,
            courseLoaded: false,
            dataLoaded: false,
            tryCompletionAction: false,
            completeAction: false,
            sendTestAction: false,
            allTableLoaded: false,
            estimates: false,
        }
        this.sendTest = this.sendTest.bind(this)
        this.tryToComplete = this.tryToComplete.bind(this)
        this.completeCourse = this.completeCourse.bind(this)
        this.startTest = this.startTest.bind(this)
        this.refresh = this.refresh.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.getModule = this.getModule.bind(this)
        this.setModalShow = this.setModalShow.bind(this)
    }

    async tryToComplete(course, modId, nextId) {
        this.setState({ tryCompletionAction: true })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        if (nextId) {
            api.courseCompleteModule({ courseId: course.id, modId, data: {}, token, lang })
                .then(async ({ success }) => {
                    if (success) {
                        const module = await this.getModule({ courseId: course.id, modId: nextId, token, lang })
                        if (module.type === 'test') {
                            this.props.history.push(`/course/${this.props.match.params.courseId}/test/${nextId}`)
                            document.location.reload()
                        } else {
                            this.props.history.push(`/course/${this.props.match.params.courseId}/mod/${nextId}`)
                        }
                        this.setState({ tryCompletionAction: false })
                    }
                })
                .catch((e) => processError(e, this.props.history))
        }
    }

    refresh() {
        // const token = cookies.get('accessToken')
        // const lang = this.props.i18n.language
        // const courseId = this.props.match.params.courseId
        // api.courseCompleteModule({ courseId, modId: this.state.module.id, data: [], token, lang }).then(() => this.componentWillMount())
        this.componentWillMount()
    }

    getCourses(page, limit, lang, accessToken) {
        return new Promise((resolve, reject) => {
            api.getCourses(page, limit, lang, accessToken)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getThemes(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getCourseInfo(id, token, lang)
                .then((res) => resolve(res.themes))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getCourse(id) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            try {
                const accessToken = cookies.get('accessToken')
                const lang = this.props.i18n.language
                // const courses = await this.getCourses(0, 1000, lang, accessToken)
                // const course = await courses.filter((course) => String(course.id) === String(id))[0]
                const course = await api.getCourseInfo(id, accessToken, lang)
                resolve(course)
            } catch (e) {
                reject(e)
            }
        })
    }

    getCourseStatus(course) {
        return new Promise((resolve) => {
            let completed, from, uncompleted, percent
            try {
                completed = ((course.themes.map((theme) => theme.modules.filter((mod) => mod.complete))).map((arr) => arr.length)).reduce((a, b) => a + b)
            } catch (e) {
                completed = 0
            }
            try {
                from = (course.themes.map((theme) => theme.modules.length)).reduce((a, b) => a + b)
            } catch (e) {
                from = 0
            }
            try {
                uncompleted = (course.themes.map((theme) => theme.modules.filter((mod) => !mod.complete))).reduce((a, b) => a.concat(b))
            } catch (e) {
                uncompleted = 0
            }
            percent = completed / from * 100
            resolve({ completed, from, percent, uncompleted })
        })
    }

    getModule(data) {
        return new Promise((resolve, reject) => {
            api.getModuleInfo(data)
                .then((mod) => {
                    mod.data = mod.data ? JSON.parse(mod.data) : { questions: [{ options: [] }] }
                    if (mod.data.type === 'test' && 'time' in mod.data) {
                        this.setState({ testWithTime: true })
                    }
                    if ('questions' in mod.data) {
                        for (let i = 0; i < mod.data.questions.length; i++) {
                            mod.data.questions[i].color = 'default'
                        }
                    }
                    resolve(mod)
                })
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    sendTest(event = {}) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const courseId = this.props.match.params.courseId
        this.setState({ sendTestAction: true })
        let data = {}
        let chosed = []
        if (!isEmpty(event)) {
            event.preventDefault()
            data = new FormData(event.target)
            for (var pair of data.entries()) {
                chosed.push(pair[1])
            }
        }
        if (timerInterval) clearInterval(timerInterval)
        api.courseCompleteModule({ courseId, modId: this.state.module.id, data: chosed, token, lang })
            .then((answers) => {
                const module = this.state.module
                const testComplete = answers.completeAnswer
                const allowToContinue = answers.success
                let corrects = answers.data.correctQuestions
                let total = answers.data.totalQuestions
                const testStatus = answers.status
                for (let i = 0; i < module.data.questions.length; i++) {
                    const answer = answers.data.answers.find((answer) => String(answer.id) === String(module.data.questions[i].id))
                    if (answer && answer.success) module.data.questions[i].color = "green"
                    else if (answer && answer.success !== undefined && !answer.success) module.data.questions[i].color = "red"
                    else module.data.questions[i].color = "default"
                }
                this.setState({ module, testStatus, testComplete, allowToContinue, corrects, total, showModal: true, sendTestAction: false })
            })
            .catch((e) => {
                processError(e, this.props.history)
            })
    }

    completeCourse() {
        this.setState({ completeAction: true })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const courseId = this.props.match.params.courseId
        api.courseCompleteModule({ courseId, modId: this.state.module.id, data: {}, token, lang })
            .then(({ success }) => {
                if (success) this.props.history.push(`/course/complete/${this.props.match.params.courseId}`)
                this.setState({ completeAction: false })
            })
            .catch((e) => processError(e, this.props.history))
    }
    async startTest() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const courseId = this.props.match.params.courseId
        const module = await this.getModule({ courseId, modId: this.props.match.params.testId, token, lang, status: 'start' })
        this.setState({ module, testHasQuestions: 'questions' in module.data })
        this.updateTimer()
    }
    updateTimer() {
        if (this.state.testWithTime) {
            let secondCounter = 0
            if (timerInterval) clearInterval(timerInterval)
            timerInterval = setInterval(() => {
                secondCounter++
                let testTimeLeft = this.state.module.data.timeLeftSeconds - secondCounter
                if (testTimeLeft <= 0) {
                    testTimeLeft = 0
                    this.setState({ showModal: true, testStatus: -2 })
                    clearInterval(timerInterval)
                }
                const minutes = Math.floor(testTimeLeft / 60)
                let seconds = testTimeLeft - minutes * 60
                seconds = seconds < 10 ? '0' + seconds : seconds
                let testTimeLeftFormated = `${minutes}:${seconds}`
                if (Number.isNaN(minutes)) testTimeLeftFormated = ''
                this.setState({ testTimeLeftFormated, testTimeLeft })
            }, 1000)
        }
    }

    getCourseEstimates(course) {
        return new Promise((resolve) => {
            const estimates = course.themes.map((theme) => ({ title: theme.title, modules: theme.modules.filter((mod) => mod.estimate).map((mod) => ({ title: mod.title, estimate: mod.estimate })) }))
            !isEmpty(estimates) ? resolve(estimates) : resolve([])
        })
    }

    setModalShow(bool, modalData = null, estimates = false) {
        if (!bool) this.setState({
            modalData: {
                name: '',
                ratableTasks: [],
                unratableTasks: [],
            },
        })
        this.setState({ estimates }, () => {
            if (modalData) this.setState({ modalShow: bool, modalData })
            else this.setState({ modalShow: bool })
        })
    }

    async componentWillMount() {
        if (timerInterval) clearInterval(timerInterval)
        this.setState({
            showModal: false,
            module: { data: { questions: [{ options: [] }] } },
        })

        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const modId = this.props.match.params.testId
        const courseId = this.props.match.params.courseId
        let arrPromise = [
            this.getCourse(courseId, lang, token).then((course) => {
                this.setState({ course, courseLodaed: true })
                this.getCourseStatus(course).then(({ completed, from, uncompleted, percent }) => this.setState({ status: { completed, from, percent, uncompleted } }))
                this.getModule({ modId, courseId, token, lang }).then((module) => {
                    if (module.type === 'test') this.props.history.push(`/course/${courseId}/test/${modId}`)
                    const pageLink = `${course.title} / ${module.title}`
                    const pageTitle = `${module.title}. ${course.title}.`
                    const pageDescription = module.content
                    this.getCourseEstimates(course).then((allTable) => {
                        if (!isEmpty(allTable)) {
                            this.setState({ allTable, allTableLoaded: true })
                        }
                    })
                    this.setState({ pageLink, pageTitle, module, pageDescription, testHasQuestions: 'questions' in module.data, moduleLoaded: true })
                })
            }),
        ]
        Promise.all(arrPromise).then(() => {
            this.setState({ dataLoaded: true })
            this.updateTimer()
        })
    }
    toggleModal() {
        if (this.state.module.data && this.state.module.data.showCorrect) {
            return () => this.setState({ showModal: !this.state.showModal })
        } else {
            return null
        }
    }
    render() {
        const { t } = this.props
        return (
            <Fragment>
                <HomeWorkModal
                    show={this.state.modalShow}
                    onHide={() => this.setModalShow(false)}
                    toggle={() => this.setModalShow(!this.state.modalShow)}
                    state={this.state.modalData}
                    props={this.props}
                    estimates={this.state.estimates}
                />
                <TestCompleteModal isOpen={this.state.showModal} toggle={this.toggleModal()} className="header-support-modal">
                    <ModalHeader toggle={this.toggleModal()} className="lg-font-size">
                        <span>{t('test-modal-result')}</span>
                        <button onClick={() => this.setState({ showModal: false })} type="button" className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                    </ModalHeader>
                    <ModalBody>
                        <div className={`${this.state.testStatus === -2 ? 'd-none' : 'subtitle md-font-size'}`}>{t('test-modal-correct-answers')} {this.state.corrects} {t('test-modal-answers-of')} {this.state.total} {t('test-modal-answers-of-end')}</div>
                        {
                            this.state.testComplete && this.state.allowToContinue ?
                                this.state.module.nextId ?
                                    <Fragment>
                                        <div className='complete-status complete'>{t('test-modal-test-passed')}</div>
                                        <Button disabled={this.state.tryCompletionAction} type="button" className="md-font-size profile-avatar-btn primary" onClick={() => this.tryToComplete(this.state.course, this.state.module.id, this.state.module.nextId)}>
                                            <div className="d-flex align-items-center">
                                                {this.state.tryCompletionAction ? <Spinner size="sm" /> : <ArrowRight size={20} />}
                                                <span className="pl-5px sm-font-size">{t('study-next-module')}</span>
                                            </div>
                                        </Button>
                                    </Fragment>
                                    :
                                    this.state.module.nextId === -1 ? '' :
                                        <Fragment>
                                            <div className='complete-status complete'>{t('test-modal-test-passed')}</div>
                                            <Button disabled={this.state.completeAction} type="button" className="md-font-size profile-avatar-btn primary" onClick={this.completeCourse}>
                                                <div className="d-flex align-items-center">
                                                    {this.state.completeAction ? <Spinner size="sm" /> : <ArrowRight size={20} />}
                                                    <span className="pl-5px sm-font-size">{t('study-end-course')}</span>
                                                </div>
                                            </Button>
                                        </Fragment>
                                :
                                <Fragment>
                                    <div className='complete-status uncomplete'>{this.state.testStatus === -2 ? t('study-test-time-is-up') : t('test-modal-test-failed')} </div>
                                    <Button type="button" className="md-font-size profile-avatar-btn primary" onClick={this.refresh}>
                                        <div className="d-flex align-items-center">
                                            <ArrowRight size={20} />
                                            <span className="pl-5px sm-font-size">{t('study-test-again')}</span>
                                        </div>
                                    </Button>
                                </Fragment>
                        }
                    </ModalBody>
                </TestCompleteModal>
                <div className="content custom-bg position-relative">
                    <Row className="w-100 mx-0">
                        <Col xs={12} md={12} className="px-0">
                            <div className="page-title">
                                <div className="float-left w-100">
                                    {
                                        this.state.pageLink !== null ?
                                            <h1 className="title lesson-dashboard md-font-size">{t('study-study')} / {this.state.pageLink}</h1>
                                            :
                                            <div className="ml-20px">
                                                <Skeleton className="title lesson-dashboard md-font-size" width={'80%'} />
                                            </div>
                                    }
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body news-bg position-relative">
                                        <div className="row w-100 mx-0">
                                            <div className="col-12 px-0">
                                                <div className="row">
                                                    <div className="col-xl-8">
                                                        <div className="col-12">
                                                            {
                                                                this.state.pageTitle !== null ?
                                                                    <div className="lesson-title xl-font-size">{this.state.pageTitle}</div>
                                                                    :
                                                                    <React.Fragment>
                                                                        <Skeleton className="xl-font-size" style={{ marginTop: '80px' }} />
                                                                        <Skeleton className="xl-font-size" />
                                                                    </React.Fragment>
                                                            }
                                                            {
                                                                this.state.pageDescription !== null ?
                                                                    <div className={`${this.state.pageDescription === '' ? 'd-none' : 'md-font-size mt-4'}`} dangerouslySetInnerHTML={{ __html: this.state.pageDescription }}></div>
                                                                    :
                                                                    <Skeleton className="md-font-size mt-4" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-xl-8">
                                                        <div className="col-12">
                                                            {
                                                                this.state.dataLoaded ?
                                                                    this.state.testHasQuestions ?
                                                                        <div className="card lesson-card">
                                                                            <div className={`${(this.state.testWithTime && this.state.testTimeLeftFormated !== '') || (this.state.module.data.attemptTotal) ? 'lesson-timer xl-font-size mb-4' : 'd-none'}`} >
                                                                                {
                                                                                    this.state.testWithTime && this.state.testTimeLeftFormated ?
                                                                                        <span className={`${this.state.testTimeLeft < 120 ? 'text-danger' : 'text-success'}`} >{t('study-time-left')}: {this.state.testTimeLeftFormated}</span> : ''
                                                                                }
                                                                                {
                                                                                    this.state.module.data.attemptTotal ? 
                                                                                        <span className={`${Number(this.state.attemptLeft) < 3 ? 'text-danger' : 'text-success'}`} >{t('study-tries-left')} {this.state.module.data.attemptLeft}/{this.state.module.data.attemptTotal}</span>
                                                                                        : ''
                                                                                }
                                                                            </div>
                                                                            
                                                                            <Form ref={(item) => this.form = item} onSubmit={(event) => this.sendTest(event)}>
                                                                                <div className="">
                                                                                    {this.state.module.data.questions.map((question, index) => {
                                                                                        return (<Questions key={question.id || index}
                                                                                            id={question.id}
                                                                                            title={question.title}
                                                                                            options={question.options}
                                                                                            questionId={question.id}
                                                                                            questionMultichoice={question.multichoice}
                                                                                            color={question.color}
                                                                                            props={this.props}
                                                                                        />
                                                                                        )
                                                                                    },
                                                                                    )}
                                                                                </div>
                                                                                <div className="lesson-btn-wrapper">
                                                                                    {
                                                                                        this.state.testComplete && this.state.allowToContinue ?
                                                                                            this.state.module.nextId ?
                                                                                                <Button type="button" className="btn profile-avatar-btn primary mr-40px p-10-20px" onClick={() => this.tryToComplete(this.state.course, this.state.module.id, this.state.module.nextId)}>
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        <ArrowRight size={20} />
                                                                                                        <span className="pl-5px sm-font-size">{t('study-next-module')}</span>
                                                                                                    </div>
                                                                                                </Button> :
                                                                                                this.state.module.nextId === -1 ? '' :
                                                                                                    <Button type="button" className="btn profile-avatar-btn primary mr-40px p-10-20px" onClick={this.completeCourse}>
                                                                                                        <div className="d-flex align-items-center">
                                                                                                            <ArrowRight size={20} />
                                                                                                            <span className="pl-5px sm-font-size">{t('study-end-course')}</span>
                                                                                                        </div>
                                                                                                    </Button>
                                                                                            :
                                                                                            <Button disabled={this.state.sendTestAction} type="submit" className="btn profile-avatar-btn primary mr-40px p-10-20px">
                                                                                                <div className="d-flex align-items-center">
                                                                                                    {this.state.sendTestAction ? <Spinner size="sm" /> : <GraduationCap size={20} />}
                                                                                                    <span className="pl-5px sm-font-size">{t('study-check-test')}</span>
                                                                                                </div>
                                                                                            </Button>
                                                                                    }

                                                                                    <Button type="button" className="btn profile-avatar-btn white p-10-20px" onClick={this.refresh}>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <ArrowsClockwise size={20} />
                                                                                            <span className="pl-5px sm-font-size">{t('study-test-again')}</span>
                                                                                        </div>
                                                                                    </Button>

                                                                                    {
                                                                                        !this.state.module.necessary && this.state.module.nextId && !this.state.testComplete ?
                                                                                            <Button
                                                                                                type="button"
                                                                                                className="btn profile-avatar-btn primary ml-40px p-10-20px"
                                                                                                onClick={() => this.tryToComplete(this.state.course, this.state.module.id, this.state.module.nextId)}
                                                                                            >
                                                                                                <div className="d-flex align-items-center">
                                                                                                    <ArrowRight size={20} />
                                                                                                    <span className="pl-5px sm-font-size">{t('study-next-module')}</span>
                                                                                                </div>
                                                                                            </Button> :
                                                                                            ''
                                                                                    }
                                                                                </div>
                                                                            </Form>
                                                                        </div>
                                                                        :
                                                                        <div className="card lesson-card">
                                                                            <Button
                                                                                type="button"
                                                                                className="btn profile-avatar-btn primary mr-40px p-10-20px"
                                                                                onClick={() => this.startTest()}
                                                                            >
                                                                                <div className="d-flex align-items-center">
                                                                                    <GraduationCap size={20} />
                                                                                    <span className="pl-5px sm-font-size">{t('study-start-test')}</span>
                                                                                </div>
                                                                            </Button>
                                                                        </div>

                                                                    :
                                                                    <TestEmulation />

                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-4 lessons-bar-wrapper d-flex flex-column">
                                                        <div className="lessons-bar">
                                                            {
                                                                this.state.courseLodaed ?
                                                                    <React.Fragment>
                                                                        <div className="bar-title">{this.state.course.title}</div>
                                                                        <div className="bar-progress">{t('study-progress')} ({this.state.status.completed}/{this.state.status.from})</div>
                                                                        <Progress className="custom-progress" color="success" value={this.state.status.percent} />
                                                                        <div className="lesson-items">
                                                                            {this.state.course.themes.map((theme) => (
                                                                                <Lessons key={theme.id}
                                                                                    id={theme.id}
                                                                                    title={theme.title}
                                                                                    modules={theme.modules}
                                                                                    courseId={this.props.match.params.courseId}
                                                                                    props={this.props}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </React.Fragment>
                                                                    :
                                                                    <SidebarEmulation />
                                                            }
                                                        </div>
                                                        {

                                                            this.state.allTableLoaded && !isEmpty(this.state.allTable) ?
                                                                <Button
                                                                    type="button"
                                                                    className="mt-3 btn profile-avatar-btn primary p-10-20px ml-auto"
                                                                    onClick={() => this.setModalShow(true, this.state.allTable, true)}
                                                                >
                                                                    <div className="d-flex align-items-center">
                                                                        <Table size={20} />
                                                                        <span className="pl-5px sm-font-size">{t('study-watch-result')}</span>
                                                                    </div>
                                                                </Button>
                                                                :
                                                                <Skeleton className="d-block w-50 ml-auto mt-3" style={{ height: '35px' }} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Fragment>
        )
    }
}

Study.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(Study)



// WEBPACK FOOTER //
// ./src/views/Study/Test.jsx